module.exports = __webpack_public_path__ + "img/zt4.73f0473.png";